import { render, staticRenderFns } from "./tenantManagement.vue?vue&type=template&id=dad73ed6&scoped=true"
import script from "./tenantManagement.vue?vue&type=script&lang=js"
export * from "./tenantManagement.vue?vue&type=script&lang=js"
import style0 from "./tenantManagement.vue?vue&type=style&index=0&id=dad73ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad73ed6",
  null
  
)

export default component.exports